module.exports = __webpack_public_path__ + "img/p1.5deb8e32.png";